module.exports = __webpack_public_path__ + "img/edelstahlpflanzgefaess.e5119b34.jpg";